import { LogOut } from 'lucide-react';
import { useSession } from '@/lib/use-session';
import { useRole } from '@/lib/use-role';
import { signOut } from '@/lib/auth';

const roleBadge: Record<string, string> = {
  owner: 'bg-purple-100 text-purple-800 border-purple-300',
  admin: 'bg-blue-100 text-blue-800 border-blue-300',
  operator: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  viewer: 'bg-slate-100 text-slate-700 border-slate-300',
};

export function UserMenu() {
  const { user } = useSession();
  const { role } = useRole();
  if (!user) return null;

  return (
    <div className="border-t border-border pt-3 mt-3">
      <div className="px-4 py-2 text-xs text-muted-foreground">
        <div className="truncate">{user.email}</div>
        <div className="mt-1">
          <span
            className={`px-1.5 py-0.5 rounded text-xs border ${roleBadge[role] ?? roleBadge.viewer}`}
          >
            role: {role}
          </span>
        </div>
      </div>
      <button
        onClick={() => signOut()}
        className="w-full flex items-center gap-2 px-4 py-2 text-sm text-foreground hover:bg-accent rounded-lg transition"
      >
        <LogOut size={14} />
        Logout
      </button>
    </div>
  );
}
